export const ADD_LIST_COURTESY = 'ADD_LIST_COURTESY';
export const ADD_COURTESY = 'ADD_COURTESY';
export const UPDATE_COURTESY = 'UPDATE_COURTESY';